// This is not an ENUM, because most of the project started using the string type for it.
// Moving the project category type to enum will require significant changes to the general translation components
// We'll cleanup as we go during PR reviews.
export const PROJECT_CATEGORY_VALUE = {
  LegalTranslation: 'LEGAL_TRANSLATION',
  PatentProsecution: 'PATENT_PROSECUTION'
};
